export const landingRoutes = [{
  path: '/landing',
  name: 'landing',
  component() {
    return import('@/views/page/landing/landing.vue')
  },
  meta: {
    title: '请求授权中'
  }
}]
